import React from 'react';

import AlignButtons from 'ub/ui/canvas/align-buttons.jsx';
import styles from './FloatMenu.scss';

export default function FloatMenu({ offsetTop, offsetLeft, isVisible, showDistribution }) {
  if (!isVisible) {
    return <div />;
  }

  const containerStyles = {
    top: offsetTop,
    left: offsetLeft,
  };

  return (
    <div className={styles.container} style={containerStyles}>
      <AlignButtons showDistribution={showDistribution} />
    </div>
  );
}

FloatMenu.propTypes = {
  offsetTop: React.PropTypes.number,
  offsetLeft: React.PropTypes.number,
  isVisible: React.PropTypes.bool,
  showDistribution: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/ui/canvas/FloatMenu.jsx